import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormStateService {
  private formStateSubject = new BehaviorSubject<any>(null);
  formState$ = this.formStateSubject.asObservable();

  private imageStateSubject = new BehaviorSubject<string | null>(null);
  imageState$ = this.imageStateSubject.asObservable();

  setFormState(state: any): void {
    this.formStateSubject.next(state);
  }

  setImageState(imageBase64: string | null): void {
    this.imageStateSubject.next(imageBase64);
  }

  clearState(): void {
    this.formStateSubject.next(null);
    this.imageStateSubject.next(null);
  }
}
